import { SEARCH_CANONICAL_ENTITIES } from "./Queries";
import {
  ADD_NEW_LEARNING_SIGNAL_MUTATION,
  ADD_NEW_LINKED_ENTITY_MUTATION,
  DISMISS_CANONICAL_ENTIY_MUTATION,
} from "./Mutations";

export class SkillClient {
  constructor(client) {
    this.client = client;
  }

  async searchCanonicalEntities({ searchString, entityType }) {
    const res = await this.client.query({
      query: SEARCH_CANONICAL_ENTITIES,
      variables: {
        searchString: searchString,
        entityType: entityType,
      },
    });
    return res.data.matchingCanonicalEntities;
  }
  async dismissCanonicalEntity({ learningEvidence, linkedCanonicalEntity }) {
    const res = await this.client.mutate({
      mutation: DISMISS_CANONICAL_ENTIY_MUTATION,
      variables: { learningEvidence, linkedCanonicalEntity },
    });
    return res.data.dismissCanonicalEntity;
  }
  async linkCanonicalEntity({
    canonicalEntity,
    reasoning,
    assignmentFeedback,
    assignmentQuestionFeedback,
  }) {
    const res = await this.client.mutate({
      mutation: ADD_NEW_LINKED_ENTITY_MUTATION,
      variables: {
        canonicalEntity,
        reasoning,
        assignmentFeedback,
        assignmentQuestionFeedback,
      },
    });
    return res.data.addNewLinkedEntity;
  }
  async addLearningSignal({ canonicalEntity, entityType, reasoning, answer }) {
    const res = await this.client.mutate({
      mutation: ADD_NEW_LEARNING_SIGNAL_MUTATION,
      variables: {
        canonicalEntity,
        entityType,
        reasoning,
        answer,
      },
    });
    return res.data.addNewLearningSignal;
  }
}
